import { DEFAULT_SERVICE_URLS, DEFAULT_ENV } from '../config'
export type ServiceEnvironment = keyof typeof DEFAULT_SERVICE_URLS
export type ServiceUrlType<TEnv extends ServiceEnvironment> = keyof typeof DEFAULT_SERVICE_URLS[TEnv]

/**
 * Get the official environment string from the provided string.
 *
 * @param env
 */
export function getEnv (env?: ServiceEnvironment): ServiceEnvironment {
  // if no env string provided, then return the default
  if (env == null) return DEFAULT_ENV
  // if the env string exists in the list of service url envs, then return it
  if (DEFAULT_SERVICE_URLS[env] != null) return env
  // otherwise, return the default
  return DEFAULT_ENV
}

export function getServiceUrl<TEnv extends ServiceEnvironment> (service: ServiceUrlType<TEnv>, env?: ServiceEnvironment): string {
  const resolvedEnv = getEnv(env)
  const services = DEFAULT_SERVICE_URLS[resolvedEnv] as Record<ServiceUrlType<TEnv>, string>
  const serviceUrl = services[service]
  return serviceUrl
}
